import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useUnblockSpaceDialogFormValidationSchema = () => {
  const { t } = useTranslation(['validation']);

  const schema = z
    .object({
      dateBlock: z.object({
        from: z.date().nullable(),
        until: z.date().nullable(),
      }),
    })
    .refine(
      data => {
        return Boolean(data.dateBlock.from && data.dateBlock.until);
      },
      {
        message: t('validation:required'),
        path: ['dateBlock'],
      },
    );

  return schema;
};
